import { Skeleton } from '@execonline-inc/execonline-ui';
import { assertNever } from '@kofno/piper';
import { ShareState } from './Stores/ShareStore/Types';

// Until the collection loads the page cannot tell a course invite from a
// collection invite, so it shows section-shaped placeholders rather than
// sections that move once it knows (DVLP-7976).
export const stillLoading = (state: ShareState): boolean => {
  switch (state.kind) {
    case 'waiting':
    case 'loading':
      return true;
    case 'ready':
    case 'searching':
    case 'reviewing':
    case 'refreshing':
    case 'publishing':
    case 'submitting':
    case 'confirming':
    case 'error':
      return false;
    default:
      return assertNever(state);
  }
};

function SectionSkeleton() {
  return (
    <div className="bg-card border border-border rounded-lg p-8">
      <div className="flex items-start gap-4 mb-6">
        <Skeleton variant="circle" size="md" />
        <div className="flex flex-1 flex-col gap-2">
          <Skeleton className="w-4/12" size="md" />
          <Skeleton className="w-7/12" />
        </div>
      </div>
      <Skeleton className="w-full" variant="rectangle" size="xl" />
    </div>
  );
}

function ShareSkeleton({ loading }: { loading: boolean }) {
  if (!loading) {
    return <></>;
  }
  return (
    <div className="space-y-6" data-intercom-target="share-invite-loading">
      <SectionSkeleton />
      <SectionSkeleton />
    </div>
  );
}

export default ShareSkeleton;
